import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { serverApi } from "../../../api";
import { SelectBuscable } from "../../../components/SelectBuscable";

const tiposDocumentoLabels = {
    RC: "Registro Civil",
    TI: "Tarjeta de Identidad",
    CC: "Cédula de Ciudadanía",
    CE: "Cédula de Extranjería",
    PE: "Permiso Especial de Permanencia",
    PT: "Permiso por Protección Temporal"
};

/* ─── Floating input ─── */
const FloatInput = ({ label, name, value, onChange, required = false }) => {
    const [focused, setFocused] = useState(false);
    const active = focused || (value && value.toString().trim() !== '');

    return (
        <div style={{ position: 'relative', marginBottom: 4 }}>
            <label style={{
                position: 'absolute', left: 14,
                top: active ? 7 : '50%',
                transform: active ? 'none' : 'translateY(-50%)',
                fontSize: active ? 10 : 14,
                fontWeight: active ? 700 : 400,
                color: focused ? '#2563eb' : (active ? '#3b82f6' : '#94a3b8'),
                transition: 'all 0.2s ease',
                pointerEvents: 'none',
                letterSpacing: active ? 0.8 : 0,
                textTransform: active ? 'uppercase' : 'none',
                zIndex: 1,
            }}>
                {label}{required && <span style={{ color: '#ef4444', marginLeft: 3 }}>*</span>}
            </label>
            <input
                type="text"
                name={name}
                value={value || ''}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                style={{
                    width: '100%',
                    padding: active ? '22px 14px 8px' : '15px 14px',
                    background: focused ? '#eff6ff' : '#f8fafc',
                    border: `1.5px solid ${focused ? '#3b82f6' : '#e2e8f0'}`,
                    borderRadius: 12,
                    color: '#0f172a',
                    fontSize: 14,
                    fontWeight: 500,
                    outline: 'none',
                    transition: 'all 0.2s ease',
                    boxSizing: 'border-box',
                    boxShadow: focused ? '0 0 0 3px rgba(37,99,235,0.12)' : 'none',
                }}
            />
        </div>
    );
};

/* ─── Select con búsqueda activa ─── */
const FloatSelect = ({ label, name, value, onChange, options }) => (
    <div style={{ marginBottom: 4 }}>
        <label style={{
            display: 'block', fontSize: 11, fontWeight: 700,
            color: '#3b82f6', textTransform: 'uppercase',
            letterSpacing: 0.8, marginBottom: 4,
        }}>
            {label}
        </label>
        <SelectBuscable
            name={name}
            asEvent
            onChange={onChange}
            isClearable={false}
            options={options.map(({ key, label: l }) => ({ value: key, label: l }))}
            value={value}
            fontSize="14px"
            height={46}
        />
    </div>
);

/* ─── Divider ─── */
const Divider = ({ label }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '12px 0 6px' }}>
        <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
        <span style={{ fontSize: 10, fontWeight: 700, color: '#2563eb', letterSpacing: 1.2, textTransform: 'uppercase' }}>
            {label}
        </span>
        <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
    </div>
);

/* ─── Componente principal ─── */
export const EditaDatosCliente = ({ show, onClose, onSave, ticket }) => {
    const [form, setForm] = useState({
        uidCliente: '',
        tipoDocumento: '',
        numeroDocumento: '',
        nombre1: '',
        nombre2: '',
        apellido1: '',
        apellido2: '',
    });

    const resetForm = () => setForm({
        uidCliente: '', tipoDocumento: '', numeroDocumento: '',
        nombre1: '', nombre2: '', apellido1: '', apellido2: '',
    });

    const getDatosCliente = async (uidCliente) => {
        const codigoEntidad = localStorage.getItem("codigoEntidad");
        const resp = await serverApi.post(`/tickets/trae-cliente`, { codigoEntidad, uidCliente });
        setForm(resp.data.cliente[0]);
    };

    useEffect(() => {
        if (show) getDatosCliente(ticket.uidCliente);
        if (!show) resetForm();
    }, [show, ticket]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = () => {
        if (!form.numeroDocumento.trim()) return;
        if (!form.nombre1.trim()) return;
        onSave({ ...form });
    };

    const nombreCompleto = [form.nombre1, form.nombre2, form.apellido1, form.apellido2]
        .filter(Boolean).join(' ').toUpperCase() || 'PACIENTE';

    const docDisplay = form.tipoDocumento
        ? `${tiposDocumentoLabels[form.tipoDocumento] || form.tipoDocumento} · ${form.numeroDocumento || '—'}`
        : form.numeroDocumento || '—';

    return (
        <>
            <style>{`
                .fm-modal .modal-content {
                    background: transparent !important;
                    border: none !important;
                    box-shadow: none !important;
                }
                .fm-btn { transition: all 0.18s ease !important; }
                .fm-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(37,99,235,0.3) !important; }
                .fm-btn-cancel:hover { background: #f1f5f9 !important; }
            `}</style>

            <Modal
                show={show}
                onHide={onClose}
                centered
                size="lg"
                dialogClassName="fm-modal"
                contentClassName="fm-modal"
            >
                <div style={{
                    background: '#ffffff',
                    borderRadius: 20,
                    overflow: 'hidden',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 20px 60px rgba(15,23,42,0.12), 0 4px 16px rgba(37,99,235,0.08)',
                }}>

                    {/* HEADER con banda azul arriba */}
                    <div style={{
                        height: 4,
                        background: 'linear-gradient(90deg, #1d4ed8, #2563eb, #38bdf8)',
                    }} />

                    <div style={{
                        padding: '22px 28px 18px',
                        borderBottom: '1px solid #f1f5f9',
                        background: 'linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)',
                        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                            {/* Avatar */}
                            <div style={{
                                width: 50, height: 50, borderRadius: '50%',
                                background: 'linear-gradient(135deg, #1e293b 0%, #2563eb 100%)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 20, flexShrink: 0,
                                boxShadow: '0 4px 14px rgba(37,99,235,0.35)',
                            }}>
                                👤
                            </div>
                            <div>
                                <div style={{
                                    fontSize: 10, fontWeight: 700, color: '#2563eb',
                                    letterSpacing: 1.4, textTransform: 'uppercase', marginBottom: 3,
                                }}>
                                    Datos del Paciente
                                </div>
                                <div style={{ fontSize: 16, fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>
                                    {nombreCompleto}
                                </div>
                                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                                    {docDisplay}
                                </div>
                            </div>
                        </div>

                        {/* Close */}
                        <button
                            onClick={onClose}
                            style={{
                                background: '#f1f5f9', border: '1.5px solid #e2e8f0',
                                borderRadius: 10, width: 32, height: 32,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                cursor: 'pointer', color: '#64748b', fontSize: 14,
                                transition: 'all 0.15s', flexShrink: 0,
                            }}
                            onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.borderColor = '#fca5a5'; e.currentTarget.style.color = '#ef4444'; }}
                            onMouseLeave={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#64748b'; }}
                        >
                            ✕
                        </button>
                    </div>

                    {/* BODY */}
                    <div style={{ padding: '22px 28px', background: '#ffffff' }}>

                        <Divider label="Identificación" />

                        <div style={{ marginBottom: 12, marginTop: 8 }}>
                            <FloatSelect
                                label="Tipo de Documento"
                                name="tipoDocumento"
                                value={form.tipoDocumento}
                                onChange={handleChange}
                                options={Object.entries(tiposDocumentoLabels).map(([k, v]) => ({ key: k, label: v }))}
                            />
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <FloatInput
                                label="Número de Documento"
                                name="numeroDocumento"
                                value={form.numeroDocumento}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <Divider label="Nombres" />

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14, marginBottom: 12, marginTop: 8 }}>
                            <FloatInput label="Primer Nombre" name="nombre1" value={form.nombre1} onChange={handleChange} required />
                            <FloatInput label="Segundo Nombre" name="nombre2" value={form.nombre2} onChange={handleChange} />
                        </div>

                        <Divider label="Apellidos" />

                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14, marginTop: 8 }}>
                            <FloatInput label="Primer Apellido" name="apellido1" value={form.apellido1} onChange={handleChange} />
                            <FloatInput label="Segundo Apellido" name="apellido2" value={form.apellido2} onChange={handleChange} />
                        </div>
                    </div>

                    {/* FOOTER */}
                    <div style={{
                        padding: '16px 28px 24px',
                        borderTop: '1px solid #f1f5f9',
                        background: '#fafbfc',
                        display: 'flex', justifyContent: 'flex-end', gap: 10,
                    }}>
                        <button
                            className="fm-btn fm-btn-cancel"
                            onClick={onClose}
                            style={{
                                padding: '10px 22px', borderRadius: 12,
                                border: '1.5px solid #e2e8f0',
                                background: '#ffffff', color: '#64748b',
                                fontSize: 14, fontWeight: 600, cursor: 'pointer',
                            }}
                        >
                            Cancelar
                        </button>

                        <button
                            className="fm-btn"
                            onClick={handleSubmit}
                            style={{
                                padding: '10px 28px', borderRadius: 12, border: 'none',
                                background: 'linear-gradient(135deg, #1d4ed8, #2563eb)',
                                color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                                boxShadow: '0 4px 14px rgba(37,99,235,0.35)',
                                display: 'flex', alignItems: 'center', gap: 8,
                            }}
                        >
                            <span style={{ fontSize: 15 }}>💾</span> Guardar
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};